import { render, staticRenderFns } from "./Licenses-Returned.vue?vue&type=template&id=475693fe&scoped=true&"
import script from "./Licenses-Returned.vue?vue&type=script&lang=js&"
export * from "./Licenses-Returned.vue?vue&type=script&lang=js&"
import style0 from "./Licenses-Returned.vue?vue&type=style&index=0&id=475693fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475693fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VIcon,VProgressCircular,VRow})
